module.exports = __webpack_public_path__ + "static/media/right_section.288d0b99.jpg";